import { useCallback } from 'react';

import { useNavigate } from 'react-router-dom';

import { ICartEntry } from '@rbi-ctg/menu';
import { useOffersContext } from 'state/offers';
import { useOrderContext } from 'state/order';

export const useCartItemEditingTools = ({
  item,
  isOffer,
}: {
  item: ICartEntry;
  isOffer?: boolean;
}) => {
  const { removeFromCart, updateQuantity } = useOrderContext();
  const { clearSelectedOffer } = useOffersContext();
  const navigate = useNavigate();

  const handleEditItem = useCallback(() => {
    navigate(item.url);
  }, [item.url, navigate]);

  const handleRemoveItem = useCallback(() => {
    isOffer ? clearSelectedOffer() : removeFromCart(item.cartId);
  }, [clearSelectedOffer, isOffer, item.cartId, removeFromCart]);

  const handleQuantityChange = useCallback(
    (value: number) => {
      updateQuantity(item.cartId, value);
    },
    [item.cartId, updateQuantity]
  );

  return {
    handleEditItem,
    handleRemoveItem,
    handleQuantityChange,
  };
};
